import Navbar from '../components/layout/Navbar';
import StockTicker from '../components/layout/StockTicker';
import Footer from '../components/layout/Footer';
import { Link } from 'react-router-dom';
import brand from '../config/brand';

export default function TermsOfUsePage() {
  return (
    <div className="min-h-screen bg-white" data-testid="terms-of-use-page">
      <StockTicker />
      <Navbar />

      {/* Header */}
      <header className="py-12 border-b-2 border-black">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <h1
            className="text-4xl md:text-6xl font-black text-black tracking-tight leading-[0.95]"
            style={{ fontFamily: "'Merriweather', serif" }}
          >
            Terms of Use
          </h1>
          <p className="text-zinc-500 mt-3 text-xs font-mono uppercase tracking-widest">Last updated: January 2026</p>
        </div>
      </header>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <div className="prose prose-lg max-w-none space-y-10">
            
            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                1. Acceptance of Terms
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                Greetings, valued customer ("You"). Welcome to {brand.name}. Your use of our service is subject to these Terms of Service ("TOS"), which may be periodically updated by {brand.name} with prior notice through email. By logging into our system, you signify your agreement to these terms.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                2. Description of Products & Service
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                {brand.name} provides information and news in the following categories: Financial news, economy news, financial trends, fintech, investment news, personal finance guidance, debt management resources, and market analysis.
              </p>
              <div className="bg-zinc-100 border-2 border-black p-4 mt-4">
                <p className="text-black font-bold leading-relaxed text-sm" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                  CONTENT ATTRIBUTION NOTICE: Some of the content displayed on this website is aggregated from third-party sources, including The Guardian and Google News. All articles, images, and other media content remain the intellectual property of their respective owners and original publishers. {brand.name} does not claim ownership of any third-party content. All rights, including copyrights and trademarks, belong to the actual owners of such rights. This content is provided for informational purposes only.
                </p>
              </div>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                3. {brand.name} Privacy Policy
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                To set up your account, specific information is required. Your information will not be released without prior consent, unless mandated by law. {brand.name} collects phone numbers of prospective members accessing information via SMS, and these numbers will not be shared.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                4. Mobile Terms & Conditions
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                By providing your consent and subscribing, you consent to receiving recurring informational SMS or MMS messages from {brand.name}. This program will deliver notifications on financial news, economy updates, financial trends, fintech, and investment news. The subscription service is at the standard rate and is accessible on various carriers. Message and data rates may apply. Carriers are not responsible for delayed or undelivered messages. Message frequency may vary.
              </p>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                To end your subscription, text STOP, END, QUIT, CANCEL, or UNSUBSCRIBE. For support, text HELP or email{' '}
                <a href={`mailto:${brand.supportEmail}`} className="text-red-600 hover:underline font-bold">
                  {brand.supportEmail}
                </a>
                . The service will continue until canceled by the customer.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                5. Member Conduct
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                You agree that {brand.name} may access, preserve, and disclose account information and content when required by law or in good faith belief. You understand that technical processing may involve network transmissions and adaptation to technical requirements. Service use is subject to usage rules set by {brand.name}, and unauthorized reproduction or distribution is prohibited.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                6. Indemnity
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                You commit to defending, indemnifying, and holding {brand.name}, its officers, agents, and employees harmless from claims arising from your subscription or use of {brand.name} services.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                7. No Resale of Service
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                The {brand.name} service is non-transferable, and you may not exploit it for commercial purposes.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                8. Modifications to Service
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                {brand.name} reserves the right to modify or discontinue the Service at any time without notice.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                9. Termination
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                {brand.name} may terminate your account and Service access under certain circumstances without prior notice. Termination includes deletion of your account's information.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                10. {brand.name} Proprietary Rights
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                The Service and Software used in connection with it are protected by intellectual property laws. Modification, distribution, or derivative works creation is prohibited.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                11. Disclaimer of Warranties
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                The Service is provided "AS-IS." {brand.name} disclaims all warranties, and usage is at your own risk.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                12. Limitation of Liability
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                {brand.name} is not liable for direct or indirect damages arising from your use of the Service.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                13. Exclusions and Limitations
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                Some jurisdictions may not allow certain limitations of warranties or liability exclusions.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                14. Notice
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                Notices from {brand.name} will be provided via email, regular mail, or postings on the Service.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                15. Trademark Information
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                You may use {brand.name} marks for marketing campaigns with permission.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                16. General Information
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                The TOS constitute the entire agreement between you and {brand.name}, governing your use of the Service.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                17. Violations
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                Please report any TOS violations to{' '}
                <a href={`mailto:${brand.legalEmail}`} className="text-red-600 hover:underline font-bold">
                  {brand.legalEmail}
                </a>
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
